export default {"src":"/_next/static/media/card-icon.0f20879e.svg","height":16,"width":24};